module.exports = __webpack_public_path__ + "static/img/hiturn-waiting.ddfaf3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hiturn-waiting.png
// module id = 2j8C
// module chunks = 90